var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49859 7.27453C7.43196 7.27453 8.18859 6.51789 8.18859 5.58453C8.18859 4.65117 7.43196 3.89453 6.49859 3.89453C5.56523 3.89453 4.80859 4.65117 4.80859 5.58453C4.80859 6.51789 5.56523 7.27453 6.49859 7.27453Z",
    stroke: "#0D2C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96059 4.59891C3.02768 -0.0919194 9.97726 -0.0865026 11.0389 4.60433C11.6618 7.356 9.95018 9.68516 8.44976 11.126C7.36101 12.1768 5.63851 12.1768 4.54434 11.126C3.04934 9.68516 1.33768 7.35058 1.96059 4.59891Z",
    stroke: "#0D2C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.8fc0e9a2ab5a7b36664026c7bf8607d9.svg";
export { ForwardRef as ReactComponent };